export function getWhatsappNumber(countryCode) {
  return countryCode === "in" ? "917835065469" : "971562198924";
}

export function getWhatsappLink(countryCode) {
  const number = getWhatsappNumber(countryCode);
  return `https://wa.me/${number}`;
}